import { http } from '@/shared/api/axios'
import type { Account, UpdateAccountRequest, EmployeeSkillTypeRequest, EmployeeCredentialTypeRequest } from '../model/types'
import type { EmployeeSkillType, EmployeeCredentialType } from '../../employee/model/types'

/**
 * Get current account details
 */
export const fetchCurrentAccount = async (): Promise<Account> => {
  const response = await http.get<Account>('/v1/account')
  return response.data
}

/**
 * Update current account
 */
export const updateAccount = async (request: UpdateAccountRequest): Promise<Account> => {
  const formData = new FormData()
  if (request.Name) formData.append('Name', request.Name)
  if (request.Description) formData.append('Description', request.Description)
  if (request.ContactEmail) formData.append('ContactEmail', request.ContactEmail)
  if (request.ContactNumber) formData.append('ContactNumber', request.ContactNumber)
  if (request.Website !== undefined) formData.append('Website', request.Website)
  if (request.LicenseNumber) formData.append('LicenseNumber', request.LicenseNumber)
  if (request.TimeZone) formData.append('TimeZone', request.TimeZone)
  if (request.Logo) formData.append('Logo', request.Logo)
  if (request.Address) formData.append('Address',request.Address)

  const response = await http.patch<Account>('/v1/account', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response.data
}

// ============================================
// Employee Skill Types
// ============================================

export const fetchEmployeeSkillTypes = async (): Promise<EmployeeSkillType[]> => {
  const response = await http.get('/v1/account/configurations/employee-skills');
  return response.data;
}

export const createEmployeeSkillType = async (data: EmployeeSkillTypeRequest): Promise<EmployeeSkillType> => {
  const response = await http.post('/v1/account/configurations/employee-skills', data);
  return response.data;
}

export const updateEmployeeSkillType = async (id: number, data: EmployeeSkillTypeRequest): Promise<EmployeeSkillType> => {
  const response = await http.put('/v1/account/configurations/employee-skills', data, {
    params: { employeeSkillId: id },
  });
  return response.data;
}

export const deleteEmployeeSkillType = async (id: number): Promise<void> => {
  await http.delete('/v1/account/configurations/employee-skills', {
    params: { employeeSkillId: id },
  });
}

// ============================================
// Employee Credential Types
// ============================================

export const fetchEmployeeCredentialTypes = async (): Promise<EmployeeCredentialType[]> => {
  const response = await http.get('/v1/account/configurations/employee-credentials');
  return response.data;
}

export const createEmployeeCredentialType = async (data: EmployeeCredentialTypeRequest): Promise<EmployeeCredentialType> => {
  const response = await http.post('/v1/account/configurations/employee-credentials', data);
  return response.data;
}

export const updateEmployeeCredentialType = async (id: number, data: EmployeeCredentialTypeRequest): Promise<EmployeeCredentialType> => {
  const response = await http.put(`/v1/account/configurations/employee-credentials/${id}`, data);
  return response.data;
}

export const deleteEmployeeCredentialType = async (id: number): Promise<void> => {
  await http.delete(`/v1/account/configurations/employee-credentials/${id}`);
}
